<template>
  <div
    v-if="isShowMark"
    class="bbp-mark"
  >
    {{name}}
  </div>
  <div
    v-else-if="isShowClockIcon"
    class="bbp-mark bbp-mark_clock"
  >
    <div v-html="CLOCK_ICON()"/>
  </div>
</template>

<script>
import {CLOCK_ICON} from '@/constants/icons'

export default {
  name: 'BBPMark',
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    }
  },
  data: () =>({
    CLOCK_ICON
  }),
  computed: {
    name () {
      const { name } = this.column
      return name
    },
    isShowMark () {
      const { projectType = {} } = this.row;
      const { getValue } = this.column;
      if (!getValue) return false
      return getValue(projectType)
    },
    isShowClockIcon () {
      const { projectType = {} } = this.row;
      const { getHourProject } = this.column;
      if (!getHourProject) return false
      return getHourProject(projectType)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-mark {
    padding: 3px 4px;
    background: rgba($color-denim,.2);
    border-radius: 2px;
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    color: $color-denim;
    max-height: 19px;

    &_clock {
      display: flex;
      justify-content: center;
      background: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPMark/BBPMark.vue